import { render } from "./LoadingAnimation.vue?vue&type=template&id=26fd437e"
import script from "./LoadingAnimation.vue?vue&type=script&lang=js"
export * from "./LoadingAnimation.vue?vue&type=script&lang=js"

import "./LoadingAnimation.vue?vue&type=style&index=0&id=26fd437e&lang=css"
/* custom blocks */
import block0 from "../i18n/LoadingAnimation.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Fpeeristics%2Frails-frontend%2Fapp%2Fassets%2Fvue%2Fshared%2Floader%2Fcomponents%2FLoadingAnimation.vue&lang=yml&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__